// Libraries
import 'jquery';
import 'popper.js';
import 'bootstrap';
import '@fancyapps/fancybox';
const moment = require('moment-timezone');
//console.log(moment.tz.guess());

import {breadcrumbProduct} from './Components/breadcrumbProduct';
import {Cookie} from './Components/cookie';
import {CookieHint} from './Components/cookieHint';
import {LoginCookie} from './Components/loginCookie';
import {Faq} from './Components/faq.js';
import {LoginFlyout} from './Components/loginFlyout';
import {LanguageFlyout} from './Components/languageFlyout';
import {timezoneSelector} from "./Components/timezoneSelector";
import {registrationForm} from "./Components/registrationForm";
import {RolePopup} from "./Components/rolePopup";

// Global functions needed on (almost) every page
(function ($) {
    new breadcrumbProduct();
    new CookieHint(new Cookie());
    new LoginCookie(new Cookie());
    new Faq();
    new LoginFlyout();
    new LanguageFlyout();
    new timezoneSelector(moment);
    new registrationForm();
    new RolePopup();
})(jQuery);


